import React, { useState, useEffect } from 'react';
import Moment from 'moment';
import PropTypes from 'prop-types';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
  IconButton,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
import { fetchPatientAppointments } from '../services/api';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import AttachmentIcon from '@material-ui/icons/Attachment';
import ApptAttachmentModal from './ApptAttachmentModal';

function PatientChartAppts(props) {
  const {
    patientId,
    classes: { loading, customSpacing },
  } = props;

  const enqueueSnackbar = useSnackbar();
  const pageLimit = 10;

  const [isLoading, setIsLoading] = useState(false);
  const [appts, setAppts] = useState([]);
  const [pageIndex, setPageIndex] = useState(0);
  const [attachment, setAttachment] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        fetchPatientAppointmentsInfo();
      } catch (err) {
        enqueueSnackbar("Unable to fetch patient's appointments");
      }
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        fetchPatientAppointmentsInfo();
      } catch (err) {
        enqueueSnackbar("Unable to fetch patient's appointments");
      }
      setIsLoading(true);
    })();
  }, [pageIndex]);

  const fetchPatientAppointmentsInfo = async () => {
    const appointments = await fetchPatientAppointments(
      patientId,
      pageLimit,
      pageIndex * 10
    );
    setAppts(appointments);
    setIsLoading(false);
  };

  const onPageBack = async () => {
    if (pageIndex === 0) {
      enqueueSnackbar('You are on the first page');
    } else {
      setPageIndex(pageIndex - 1);
    }
  };

  const onPageForward = async () => {
    setPageIndex(pageIndex + 1);
  };

  return isLoading ? (
    <div className={props.classes.loading}>
      <CircularProgress />
    </div>
  ) : (
    <>
      <div style={{ overflow: 'scroll' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Doc</TableCell>
              <TableCell>Where</TableCell>
              <TableCell>When</TableCell>
              <TableCell>Created On</TableCell>
              <TableCell>Visit-Reason</TableCell>
              <TableCell>Portal-Notes</TableCell>
              <TableCell>Created By</TableCell>
              <TableCell>Cancelled By</TableCell>
              <TableCell>Cancelled Date</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Cancel-Reason</TableCell>
              <TableCell>Attachments</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {appts
              .sort((a1, a2) =>
                Moment(a1.time).isAfter(Moment(a2.time)) ? -1 : 1
              )
              .map((appt) => (
                <TableRow key={appt.id}>
                  <TableCell>{`${appt.tenancy && appt.tenancy.provider.title} ${
                    appt.tenancy &&
                    appt.tenancy.provider &&
                    appt.tenancy.provider.user.firstName
                  } ${
                    appt.tenancy &&
                    appt.tenancy.provider &&
                    appt.tenancy.provider.user.lastName
                  }`}</TableCell>
                  <TableCell>
                    {appt && appt.tenancy && appt.tenancy.location}
                  </TableCell>
                  <TableCell>
                    {Moment(appt.time).format('h:mm a - MM/DD/YYYY ')}
                  </TableCell>
                  <TableCell>
                    {Moment(appt.createdAt).format('h:mm a - MM/DD/YYYY ')}
                  </TableCell>
                  <TableCell>
                    {appt && appt.patientReason ? appt.patientReason : '-'}
                  </TableCell>
                  <TableCell>
                    {appt && appt.portalNotes ? appt.portalNotes : '-'}
                  </TableCell>
                  <TableCell>{`${
                    appt.createdByInfo && appt.createdByInfo.firstName
                      ? appt.createdByInfo.firstName
                      : '-'
                  }  ${
                    appt.createdByInfo && appt.createdByInfo.lastName
                      ? appt.createdByInfo.lastName
                      : '-'
                  }`}</TableCell>
                  {/* <TableCell>
                  {appt.statusUpdated
                    ? appt.statusUpdated.firstName + appt.statusUpdated.lastName
                    : '-'}
                </TableCell> */}
                  <TableCell>
                    {appt.cancelledBy
                      ? appt.cancelledBy
                      : '-'}
                  </TableCell>
                  <TableCell>
                    {appt.cancelledDate
                      ? Moment(appt.cancelledDate).format(
                          'h:mm a - MM/DD/YYYY '
                        )
                      : '-'}
                  </TableCell>
                  <TableCell>{appt.status}</TableCell>
                  <TableCell>
                    {appt && appt.cancelReason
                      ? appt.cancelReason.concat(
                          ' : ',
                          appt && appt.reasonOfCancelAppt
                        )
                      : '-' + appt && appt.reasonOfCancelAppt}
                  </TableCell>
                  <TableCell>
                    {appt.isAttachment ? (
                      <IconButton
                        title={appt.isAttachment ? 'View Attachment' : null}
                      >
                        <AttachmentIcon onClick={() => setAttachment(appt)} />
                      </IconButton>
                    ) : (
                      <span className={props.classes.customSpacing}>-</span>
                    )}
                    {/* <IconButton
                    size="small"
                    title={appt.isAttachment ? "View Attachment" : "No Attachment Found"}
                  >

                    {appt.isAttachment ? <AttachmentIcon onClick={() => setAttachment(appt)} /> :
                    '-'}
                  </IconButton> */}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </div>
      {attachment && (
        <ApptAttachmentModal
          viewOnly
          open={!!attachment}
          note={{
            id: attachment.id,
            body: attachment.body,
            // patientId: attachment.patient.id,
            // patientName: attachment.patient.name,
            // toProviderId: attachment.toProvider.id,
            // toProviderName: attachment.toProvider.name,
            // toProviderImageUrl: attachment.toProvider.imageUrl,
            // fromProviderId: attachment.fromProvider.id,
            // fromProviderName: attachment.fromProvider.name,
            // fromProviderImageUrl: attachment.fromProvider.imageUrl,
            // archivedById: attachment.archivedById,
            createdAt: attachment.createdAt,
          }}
          onClose={() => setAttachment(null)}
        />
      )}
      <div className={props.classes.pageTurners}>
        <IconButton disabled={pageIndex === 0}>
          <ArrowBackIosIcon
            style={{ opacity: pageIndex === 0 ? '0.5' : '1.0' }}
            color="primary"
            variant="contained"
            onClick={onPageBack}
          />
        </IconButton>
        <IconButton>
          <ArrowForwardIosIcon
            style={{ opacity: appts.length < pageLimit ? '0.5' : '1.0' }}
            color="primary"
            variant="contained"
            onClick={onPageForward}
          />
        </IconButton>
      </div>
    </>
  );
}

PatientChartAppts.propTypes = {
  patient: PropTypes.object,
};

const styles = () => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  pageTurners: {
    width: '100%',
    marginTop: '5px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  customSpacing: {
    marginLeft: '21px',
    display: 'block',
  },
});

export default withStyles(styles)(PatientChartAppts);
